<template>
  <b-modal
    title="Listar produtos"
    no-close-on-backdrop
    size="lg"
    ok-only
    centered
    hide-footer
    header-bg-variant="orange"
    header-text-variant="light"
    v-model="open"
    :busy="loading"
  >
    <b-row class="container">
      <b-col cols="12" class="my-2 text-center">
        <h5>Produtos Vinculados</h5>
      </b-col>

      <b-col cols="12" class="mt-2 mb-4">
        <b-table
          striped
          outlined
          hover
          responsive
          :fields="table.headers"
          :items="table.records"
          class="mt-3"
        >
          <template #cell(action)="data">
            <b-button
              @click="deleteProduct(data.item)"
              variant="danger"
              title="Exluir o atributo"
              size="sm"
              class="ml-4"
            >
              <i class="fas fa-trash"></i>
            </b-button>
          </template>
        </b-table>
      </b-col>
      <b-col cols="12" class="d-flex align-items-center justify-content-center">
      <b-pagination
        v-model="pagination.currentPage"
        :total-rows="pagination.total"
        :per-page="pagination.itemsPerPage"
        :disabled="loading"
      ></b-pagination>
    </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import { mapActions } from 'vuex';
import makeToast from '@/mixins/makeToast';
export default {
  name: 'SelectedProductsAttributeModal',
  mixins: [makeToast],
  emits: ['getVariation'],
  
  data() {
    return {
      loading: false,
      open: false,
      shopkeeperId: null,
      pagination: {
        currentPage: 1,
        itemsPerPage: 1,
        total: 1,
      },
      table:{
        headers: [
          {
            key: 'id',
            thClass: 'd-none',
            tdClass: 'd-none',
          },
          {
            key: 'product',
            label: 'Produto',
          },
          {
            key: 'productVariation',
            label: 'Produto Variação',
          },
          {
            key: 'attribute',
            label: 'Atributo Pai',
          },
          {
            key: 'attributeChild',
            label: 'Atributo Filho',
          },
          {
          key: 'action',
          label: 'Ação',
          },
        ],
        records:[]
      },
    };
  },

  watch: {
    'pagination.currentPage': function () {
      this.get();
    },
  },
  methods: {
    ...mapActions('shopkeeper', [
      'getDataVariationSelectedProducts',
      'deleteProductAttributeId'
    ]),

    toggleOpen({ shopkeeperId = null }) {
      this.open = !this.open;
      this.clean()
      this.shopkeeperId = shopkeeperId;
      this.get();
    },
    get() {
      this.optionsAttribute = [];
      this.table.records = [];
      
      this.$store.dispatch('startLoader');
      this.$store.dispatch('shopkeeper/getDataVariationSelectedProducts', this.shopkeeperId)
        .then((response) => {
          const { total } = response.data.data.data || {};
          this.pagination.itemsPerPage = 15;
          this.pagination.total = total;

          const result = response.data.data.data.data;

          result.forEach(element => {
            element.attributes.forEach(item => {
              let products = {
                "id": element.id,
                "product": element.product,
                "productId": element.productId,
                "codebar": element.codebar,
                "idVariation": item.idVariation,
                "attribute": item.name, 
                "productVariation": item.productVariation,
                "attributeChild": item.value
              }
              this.table.records.push(products);
            });
          });
        })
        .catch((error) => {
          this.makeToast(
            'Erro',
            `Houve um erro ao buscar os dados`,
          );
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
    deleteProduct(item) {
      this.$store.dispatch('startLoader');
      this.$store.dispatch('shopkeeper/deleteProductAttributeId', item.idVariation)
      .then((resp) => {
        this.makeToast(
          'Sucesso',
          'Apagado com sucesso!',
          'success'
        );
        
        const index = this.table.records.findIndex(element => element.idVariation === item.idVariation);
        if (index !== -1) {
          this.table.records.splice(index, 1);
        }

      })
      .catch(() => {
        this.makeToast(
          'Erro',
          'Houve um erro ao excluir produto do serviço!',
          'danger'
        );
      })
      .finally(() => {
        this.$store.dispatch('endLoader');
      });
    },
    close() {
      this.clean();
      this.open = !this.open;
    },
    clean() {

    },
  },
};
</script>